// extracted by mini-css-extract-plugin
module.exports = {"detail":"Detail_detail_3qxal"};